/* eslint-disable max-statements */
import axios from 'axios';
import type { KitchenDataOut } from '@rta/rta-blueprint-library';

import { Controller } from '@context';

export type RenderingPayload = {
	raw?: string | null;
	ai?: string | null;
	canonical?: 'raw' | 'ai';
	signature?: string;
};

export type SaveCustomerBlueprintParams = {
	controller: Controller,
	customerEmail: string,
	getToken: () => Promise<string>,
	mode: string,
	kitchenDataOverride?: KitchenDataOut,
	renderings?: RenderingPayload,
	setSuccess?: (success: string) => void,
	setError?: (error: string) => void
};

export const saveCustomerBlueprint = async (params: SaveCustomerBlueprintParams): Promise<[string | null, string | null]> => {
	// eslint-disable-next-line no-empty-function, @typescript-eslint/no-empty-function
	const { controller, getToken, setSuccess, setError, mode, customerEmail, kitchenDataOverride, renderings } = params;

	const kitchen = controller?.kitchen ?? null;
	const blueprint = kitchen?.context?.blueprint ?? null;
	const submissionId = blueprint?.submissionId ?? blueprint?.id;

	console.log('saveCustomerBlueprint:params', customerEmail, submissionId, kitchen);

	try {
		const token = await getToken();
		const apiUrl = mode === 'test' ? import.meta.env.VITE_API_URL_TEST : import.meta.env.VITE_API_URL;
		const serialized = kitchenDataOverride ?? kitchen.serialize();
		const body = renderings ? { ...serialized, renderings } : serialized;
		const response = await axios.put(`${apiUrl}/customers/${customerEmail}/blueprints/${submissionId}`, body, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});

		console.log('response:save-api', response.status, response.data);
		if (response.status === 200) {
			if (setSuccess) {
				console.log('response:save-api:success');
				setSuccess('Blueprint saved successfully');
			}
			return [response.data ?? null, null];
		}

		throw new Error('Error saving blueprint');
	} catch (error) {
		if (axios.isAxiosError(error) && error.response) {
			const { status, statusText, data } = error.response;
			console.error(
				`[save-customer-blueprint] non-2xx response for ${submissionId}`,
				{ status, statusText, body: typeof data === 'string' ? data : JSON.stringify(data) }
			);
		} else {
			console.error(`[save-customer-blueprint] request failed for ${submissionId}`, error);
		}
		if (setError) setError('Error saving blueprint');
		return [null, 'Error saving blueprint'];
	}

	return [null, null];
};
